module.exports = __webpack_public_path__ + "img/descentandrescue.c6d8cfbb.png";